import { useCallback } from 'react';
import type { LeadData } from '@hub/shared-types';
import { CapturePluginLeadUseCase } from '@/application/use-cases/CapturePluginLeadUseCase';
import type { CapturePluginLeadResult } from '@/application/use-cases/CapturePluginLeadUseCase';
import { EnqueueLeadUseCase } from '@/application/use-cases/EnqueueLeadUseCase';
import { IndexedDbLeadQueueRepository } from '@/infrastructure/repositories/IndexedDbLeadQueueRepository';
import type { DeviceSession } from '@/domain/entities/DeviceSession';

const capturePluginLeadUseCase = new CapturePluginLeadUseCase(
  new EnqueueLeadUseCase(new IndexedDbLeadQueueRepository())
);

interface UsePluginLeadCaptureResult {
  /** Captura um lead reportado por `onLeadCapture` (contrato `PluginProps`,
   * ADR-004) — HUB-237, CA-15/CA-18/CA-20. Mesmo caminho de enfileiramento
   * de `useFakeLeadCapture` (`EnqueueLeadUseCase`, HUB-236): grava na
   * `lead_queue` do IndexedDB, sincronizada em segundo plano
   * independentemente do plugin ativo (CA-15). */
  captureLead: (
    session: DeviceSession,
    lead: LeadData,
    consentAccepted: boolean,
    consentTextVersion: number
  ) => Promise<CapturePluginLeadResult>;
}

export function usePluginLeadCapture(): UsePluginLeadCaptureResult {
  const captureLead = useCallback(
    (
      session: DeviceSession,
      lead: LeadData,
      consentAccepted: boolean,
      consentTextVersion: number
    ): Promise<CapturePluginLeadResult> =>
      capturePluginLeadUseCase.execute(session, lead, consentAccepted, consentTextVersion),
    []
  );

  return { captureLead };
}
